<template>
  <div>
    <callout
      class="mb-3"
      class-main="bg-secondary-13"
      class-panel="p-2"
      :has-toggle="true"
    >
      <div class="row py-2">
        <div class="col  align-items-center">
          <span class="text-gray font-16">PO ID:</span>
          <div class="color-black font-16 font-weight-bold">
            {{ value.purchaseOrderId }}
          </div>
        </div>
        <div class="col  align-items-center">
          <span class="text-gray font-16">Estatus:</span>
          <div class="color-black font-16 font-weight-bold">
            {{ getStatusDescription(value.status) }}
          </div>
        </div>
        <div class="col  align-items-center">
          <span class="text-gray font-16">DOE Balance Amount:</span>
          <div class="font-16 font-weight-bold" :class="doeBalanceAmountClass">
            {{ doeBalanceAmount | price }}
          </div>
        </div>
        <div class="col-2 d-flex justify-content-center">
          <span class="color-gray-8 font-14 pr-3 mt-1">
            {{ value.lastUpdatedDate | date }}
          </span>
        </div>
      </div>
      <template #edition>
        <div class="p-2 mt-1">
          <div
            v-for="(row, i) in value.details"
            :key="`address-item-${i}`"
            class="bg-white rounded p-3 row mb-2 mx-0"
          >
            <div class="col-12 col-md-3">
              <span class="color-secondary-6 font-14 font-weight-normal">
                Número de Cifra:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.fullNumber }}
              </div>
            </div>
            <div class="col">
              <span class="color-secondary-6 font-14 font-weight-normal">
                Line Number:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.lineNumber }}
              </div>
            </div>
            <div class="col">
              <span class="color-secondary-6 font-14 font-weight-normal">
                Line Status:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.lineStatus | empty }}
              </div>
            </div>
            <div class="col">
              <span class="color-secondary-6 font-14 font-weight-normal">
                Merchandise Amount:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.merchandiseAmount | price }}
              </div>
            </div>
            <div class="col">
              <span class="color-secondary-6 font-14 font-weight-normal">
                Merchandise VC:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.merchandiseAmountVC | price }}
              </div>
            </div>
            <div class="col">
              <span class="color-secondary-6 font-14 font-weight-normal">
                DOE Balance Amount:
              </span>
              <div class="color-black font-16 font-weight-normal">
                {{ row.doeBalanceAmount | price }}
              </div>
            </div>
          </div>
          <custom-result-not-found v-if="value.details.length == 0" />
        </div>
      </template>
    </callout>
  </div>
</template>

<script>
import poStatuses from '@/utils/constants/sifdePOStatus';
import CustomResultNotFound from 'custom-result-not-found';
export default {
  name: 'SIFDERow',
  components: {
    CustomResultNotFound,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    doeBalanceAmount() {
      return (this.value.details || []).reduce(
        (sum, row) => sum + (row.doeBalanceAmount || 0),
        0
      );
    },
    doeBalanceAmountClass() {
      return this.doeBalanceAmount < 0 ? 'text-danger' : 'text-green';
    },
    digitNumber() {
      return this.value.purchaseOrderId.toString().length;
    },
  },
  methods: {
    getStatusDescription(status) {
      return poStatuses[status] ?? 'No Disponible';
    },
  },
};
</script>

<style lang="scss" scoped></style>
